import styled from 'styled-components';
import { Text } from '@mantine/core';
import type { ComponentProps } from 'react';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainText = asPlainComponent<ComponentProps<typeof Text>>(Text);

export const DetailTitle = styled(PlainText)`
	font-size: 14px;
	line-height: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.v3.colors.dark[0]};
`;

export const DetailLabel = styled(PlainText)`
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.v3.colors.dark[8]};
`;
